import { i18nErrorMessage } from 'utils/i18nUtils';

const errorMessage = i18nErrorMessage();

export const defaultErrorTitle = errorMessage.title;

export const defaultErrorMsg = errorMessage.body;
